<template>
  <div>
    <ElibraryMain></ElibraryMain>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import ElibraryMain from "@/components/public-e-library/ElibraryMain.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'ELibraryView',
  components: {
    AppFooter,
    ElibraryMain

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>